import { useMemo } from 'react';

export const useAppsFeaturesRolesFromAssignedRoles = (assignedRoles = []) =>
  useMemo(() => {
    const grouped = {};

    assignedRoles.forEach(item => {
      const {
        communityTag = 'GLOBAL',
        communityName = 'Global',
        appTag,
        appName,
        featureTag,
        featureName,
        roleTag,
        roleName,
        sources,
      } = item;

      // Create a unique key for the app based on appTag and communityTag
      const appKey = `${appTag}::${communityTag}`;

      // Ensure the app exists
      if (!grouped[appKey]) {
        grouped[appKey] = {
          appTag,
          appName,
          communityTag,
          communityName,
          features: {},
        };
      }

      const app = grouped[appKey];

      // Ensure the feature exists within the app
      if (!app.features[featureTag]) {
        app.features[featureTag] = {
          featureTag,
          featureName,
          roles: {},
        };
      }

      const feature = app.features[featureTag];

      // Ensure the role exists within the feature
      if (!feature.roles[roleTag]) {
        feature.roles[roleTag] = {
          roleTag,
          roleName,
          sources,
        };
      }
    });

    // Convert the nested objects into arrays
    const result = Object.values(grouped).map(app => ({
      ...app,
      features: Object.values(app.features).map(feature => ({
        ...feature,
        roles: Object.values(feature.roles),
      })),
    }));

    return result;
  }, [assignedRoles]);
